import type { ComponentChildren } from "preact";
import { useMemo } from "preact/hooks";
import { longPress } from "./long-press";
import type { RollRequest } from "./rolls";
import { useSheetActions } from "./sheet-context";

interface Props {
  request: RollRequest;
  class?: string;
  title?: string;
  disabled?: boolean;
  children: ComponentChildren;
}

/** A Roll button on the sheet: tap to roll, long-press to enter the physical dice (issue #19). */
export function RollButton({ request, class: extra, title, disabled, children }: Props) {
  const { roll } = useSheetActions();
  const handlers = useMemo(
    () => longPress<HTMLButtonElement>((e) => (e.currentTarget instanceof HTMLButtonElement ? e.currentTarget : null), () => roll(request), () => roll(request, { physical: true })),
    [roll, request],
  );
  return (
    <button type="button" class={`roll${extra ? ` ${extra}` : ""}`} title={title ?? "Tap to roll; hold to enter a physical die"} disabled={disabled} {...handlers}>
      {children}
    </button>
  );
}
